export default __webpack_public_path__ + "static/idea 2-85b801a8e5b08de2d405b510b3c0fd08.wav";